<template>
  <div class="download-wrap">

    <div class="viewCon">
      <img src="/static/img/download/logo.png" alt="" class="logoImg">
      <img src="/static/img/download/title.png" alt="" class="titleImg">
      <!-- 薄盒致力于帮助用户构建自己的下一代可视化数字身份，基于区块链技术确权数字内容，提供可信存证技术、藏品数字凭证技术服务。 -->
      <div class="describe">{{$t('download.text1')}}</div>
      <div v-on:click="download" class="download-btn">下载App</div>
      <div class="bottomDiv">
        <!-- 开发商：北京擘盒科技有限公司 -->
        <div class="name1">{{$t('download.text2')}}</div>
        <!-- 版本号： -->
        <div class="name2">{{$t('download.text3')}}
          <!-- Android 1.2.8 / ios 1.2.6 -->
          <template v-if="versionAndroid">Android {{versionAndroid}} /</template>
          <template v-if="versionIos">ios {{versionIos}}</template>
        </div>
      </div>
      <div class="name3">
        <!-- 《隐私协议》 -->
        <a href="/publicAgreement?agreementCode=H5YSZC">{{$t('download.text4')}}</a>
        <!-- 《薄盒用户协议》 -->
        <a href="/publicAgreement?agreementCode=H5YHXY">{{$t('download.text5')}}</a>
      </div>
    </div>

    <div class="mask-wrap" v-if="browserType">
      <img class="close" @click="browserType =false" src="/static/img/icon_close@2x.png" alt="">
      <img src="http://p.iliyu.com.cn/h5/image/download-arrow.png" class="download-arrow" />
      <div class="open-tip">
        <img src="http://p.iliyu.com.cn/h5/image/browser-icon.png" class="browser-icon" />
        <!-- 点击右上角选择浏览器打开 -->
        <div class="browser-title">{{$t('download.text6')}}</div>
      </div>
      <!-- 如浏览器打开失败，请移步桌面直接打开应用 -->
      <div class="browser-tip">{{$t('download.text7')}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        browserType: false, // 判断是否为微信浏览器
        isWeixin: false,
        versionAndroid: "",
        versionIos: ""
      };
    },
    mounted() {
      var ua = window.navigator.userAgent.toLowerCase();

      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.isWeixin = true;
      } else {
        this.isWeixin = false;
      }
      this.getVersion()
    },
    created() {
      console.log(this.$baseRequest);
      this.config = {
        isAndroid: /Android/i.test(navigator.userAgent), //判断是否为移动端
        isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //判断是否为IOS
      };
      console.log(this.config)
    },
    methods: {
      /*
       * 判断是否为微信浏览器
       */
      isWeiXin() {
        let ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") return true;
        return false;
      },
      /*
       * 跳转下载页面
       */
      download() {
        if (this.config.isAndroid) {
          if (this.isWeixin) {
            this.browserType = true;
          } else {
            window.location.href = "https://cdn.mintstech.cn/mintstech.apk?v=" + Date.now();
          }
        }
        if (this.config.isIOS) {
          if (this.isWeixin) {
            this.browserType = true;
          } else {
            window.location.href = "https://itunes.apple.com/cn/app/id1638026274?mt=8"
          }
        }
      },
      getVersion() {
        this.$fetchql.Post('version/latest').then((
          resopnse) => {
          if (resopnse.code == 0) {
            resopnse.data.forEach(item => {
              if (item.clientchannel == 1) {
                if (item.version) {
                  this.versionAndroid = item.version
                }
              } else if (item.clientchannel == 2) {
                if (item.version) {
                  this.versionIos = item.version
                }
              }
            });
          }
        })
      }

    },
  };

</script>
<style lang="less" scope="scope">
  .download-wrap {
    min-height: 100vh;
    background: url(/static/img/download/downloadBg.png) no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    position: relative;

    .viewCon {
      padding-top: 285px;

      .logoImg {
        width: 99px;
        height: 99px;
        display: block;
        margin: 0 auto 12px;
      }

      .titleImg {
        display: block;
        width: 257.5px;
        height: 19px;
        margin: 0 auto 22px;
      }

      .describe {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 18.5px;
        padding: 0 30px 28px;
        text-align: justify;
      }

      .download-btn {
        width: 315px;
        height: 45px;
        background: url(/static/img/download/downLoadBtn.png) no-repeat;
        margin: 0 auto;
        background-size: contain;
        line-height: 45px;
        text-align: center;
        margin-bottom: 90px;

        font-size: 15px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #000000;
      }

      .bottomDiv {
        padding: 0 30px 5px;
        display: flex;

        .name1,
        .name2 {
          flex: 1;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: bold;
          color: #6D7278;
          margin-bottom: 5px;
        }

        .name1 {
          margin-right: 15px;
        }


      }

      .name3 {
        padding-bottom: 111px;
        text-align: center;

        a {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: bold;
          color: #1CE89E;
          text-decoration: none;
        }
      }
    }



    .mask-wrap {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.7);

      .close {
        width: 24px;
        height: 24px;
        margin-top: 10px;
        margin-left: 10px;
      }

      .download-arrow {
        width: 44px;
        height: 77px;
        position: absolute;
        right: 68px;
        margin-top: 8px;
      }

      .open-tip {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 176px 0 5px;

        .browser-icon {
          width: 24px;
          height: 24px;
          display: block;
        }

        .browser-title {
          font-size: 20px;
          font-family: PingFangSC;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          margin-left: 5px;
        }
      }

      .browser-tip {
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/download.vue